import { mapGetters, mapState } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentMember: (state) => state.currentMember,
    currentMemberPetList: (state) => state.currentMemberPetList,
    currentLiffId: (state) => state.currentLiffId,
  }),
  ...mapGetters('auth', [
    'isLoggedIn',
    'isLiffInit',
    'isBlock',
    // 'isHasMemberLevel',
  ]),
};

export const merchantComputed = {
  ...mapState('merchant', {
    currentMerchant: (state) => state.currentMerchant,
    currentUnpaidContiner: (state) => state.currentUnpaidContiner,
  }),
  ...mapGetters('merchant', [
    'isSiteEnabled',
    'isMemberLevelEnabled',
    'hasDepositModule',
    'isHasReservationInCart',
  ]),
};

export const orderComputed = {
  ...mapState('order', {
    currentApplicablePrepaidOrderList: (state) => state.currentApplicablePrepaidOrderList,
  }),
};
